import styled from 'styled-components'

import { Tag } from 'components/ui'
import { getValidIcon, Icon } from 'components/ui/Icon'
import { Container } from 'components/ui/deprecated/Layout'
import { Text } from 'components/ui/deprecated/Text'
import useDrawer from 'lib/hooks/useDrawer'
import {
  DynamicFormStepsStoryblok,
  DynamicFormStoryblok,
} from 'lib/storyblok/types'
import { addAlphaToColor, dashedLine } from 'lib/style'
import { textByLine } from 'lib/utils/content'
import { cn } from 'lib/utils/tailwind'

type Props = {
  content: DynamicFormStoryblok | DynamicFormStepsStoryblok
}

export const DynamicFormHeader = ({ content }: Props): JSX.Element => {
  const { drawer } = useDrawer()
  const isDrawer = !!drawer

  const { tag, title, description, details } = content

  return (
    <Header variant={isDrawer ? 'full' : 'typography'} isDrawer={isDrawer}>
      {tag && <Tag>{tag}</Tag>}

      {title && (
        <HeaderTitle as="h2" variant="title/large">
          {title}
        </HeaderTitle>
      )}

      {description &&
        textByLine(description, (part) => (
          <Text
            as="p"
            variant="eighteen"
            className={cn('mt-4', details?.length && 'mb-5')}
          >
            {part}
          </Text>
        ))}

      <EventDetails>
        {details?.map((detail) => {
          const typedIcon = getValidIcon(detail.icon)
          return (
            <EventDetail key={detail._uid}>
              {detail.icon && typedIcon && (
                <Icon size={20} icon={typedIcon} className="opacity-60" />
              )}
              <Text as="p" variant="sixteen/regular">
                {detail.text}
              </Text>
            </EventDetail>
          )
        })}
      </EventDetails>

      <Divider />
    </Header>
  )
}

const Header = styled(Container)<{ isDrawer: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;

  padding-top: 1.25rem;

  ${({ theme }) => theme.media.md} {
    padding-top: ${({ isDrawer }) => (isDrawer ? '1.25rem' : '3.75rem')};
  }
`

const HeaderTitle = styled(Text)`
  margin-top: 1rem;
`

const EventDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;

  margin-top: 1.25rem;
`
const EventDetail = styled.div`
  display: flex;
  gap: 0.25rem;

  align-items: center;
  justify-content: center;
`

const Divider = styled.div`
  height: 1px;
  margin-top: 2rem;
  margin-bottom: 2rem;

  ${({ theme }) =>
    dashedLine('bottom', addAlphaToColor(theme.colors.foreground.default, 60))};
`
